


























































import HMDialog from '@/web/components/common/HMDialog';

export default {
  name: 'PlaylistModal',
  props: {
    mediaItemsSelected: {
      type: Array,
    },
    playlist: {
      type: Object,
      default(): PlaylistResponse {
        return ({
          id: null,
          playlist_name: 'New playlist',
          featured: false,
          content: this.mediaItemsSelected,
          archived: false,
        } as unknown) as PlaylistResponse;
      },
    },
    playlists: {
      type: Array as () => PlaylistResponse[],
    },
    confirm: null,
    delete: null,
  },
  data() {
    return {
      inProgress: false,
    };
  },
  computed: {
    title() {
      if (this.isEditAction()) {
        return `${this.$t('PRODUCTS.TITLE.EDIT_PLAYLIST')}
					(${this.playlist.content.length}
					${this.$tc('PRODUCTS.TEXT.ITEMS_VARIANT', this.playlist.content.length)})`;
      }
      return `${this.$t('PRODUCTS.TITLE.NEW_PLAYLIST')}
				(${this.mediaItemsSelected.length}
				${this.$tc('PRODUCTS.TEXT.ITEMS_VARIANT', this.mediaItemsSelected.length)})`;
    },
    submitButtonLabel() {
      if (this.isEditAction()) {
        return this.$t('PRODUCTS.BUTTON.SAVE');
      }
      return this.$t('PRODUCTS.BUTTON.CREATE');
    },
  },
  methods: {
    changeFeaturedPlaylist(playlist, event) {
      if (!playlist.featured) {
        let playlistName = null;
        const featuredPlaylistExists = this.playlists.some(item => {
          playlistName = item.playlist_name;
          return item.featured;
        });

        if (featuredPlaylistExists) {
          this.showFeatureWindow(playlistName);
        } else {
          playlist.featured = event;
        }
      } else {
        playlist.featured = event;
      }
    },
    async submit() {
      try {
        this.inProgress = true;

        await this.confirm(this.playlist);
        this.$emit('close');
      } finally {
        this.inProgress = false;
      }
    },
    async deletePlaylist() {
      try {
        this.inProgress = true;

        await this.delete(this.playlist);
        this.$emit('close');
      } finally {
        this.inProgress = false;
      }
    },
    isEditAction() {
      return this.playlist.id !== null;
    },
    showFeatureWindow(playlistName) {
      const title = this.$t('PRODUCTS.TITLE.FEATURE_PLAYLIST');
      const subtitle = this.$t('PRODUCTS.TEXT.FEATURE_PLAYLIST_REPLACE');
      const text = this.$t('PRODUCTS.TEXT.FEATURE_PLAYLIST_TEXT', {
        playlistName,
      });
      const confirmButton = this.$t('PRODUCTS.BUTTON.FEATURE_PLAYLIST_CONFIRM');
      const confirm = () => {
        this.playlists.forEach(item => {
          item.featured = false;
        });
        this.playlist.featured = true;
      };
      const discard = () => {};

      this.$modal.show(HMDialog, {
        title,
        subtitle,
        text,
        confirmButton,
        confirm,
        discard,
      });
    },
  },
};
